module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "kpiAssignmentDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "kpiAssignmentDialogForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM1000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.KM1001) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedClient) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM1013) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedProject) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM1002) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedKpiGroup) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM1003) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfselectedEvaluationRuleGuid) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedClientGuid,
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalClientSelect",
      "afterChange": _vm.selectedClientGuidChanged,
      "disabled": _vm.feature.isAudiTarget &&
        _vm.feature.isEnabled('audi_importers')
    },
    model: {
      value: (_vm.selectedClientGuid),
      callback: function($$v) {
        _vm.selectedClientGuid = $$v
      },
      expression: "selectedClientGuid"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalKpiGroupSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedKpiGroupGuid,
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalKpiGroupSelect",
      "placeholder": _vm.lang.KM1006,
      "disabled": _vm.kpiGroupsOfSelectedClient.length < 1,
      "afterChange": _vm.selectedKpiGroupGuidChanged
    },
    model: {
      value: (_vm.selectedKpiGroupGuid),
      callback: function($$v) {
        _vm.selectedKpiGroupGuid = $$v
      },
      expression: "selectedKpiGroupGuid"
    }
  }, _vm._l((_vm.kpiGroupsOfSelectedClient), function(kpiGroup) {
    return _c('option', {
      key: kpiGroup.KPIGroupGuid,
      domProps: {
        "value": kpiGroup.KPIGroupGuid
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupCode) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalKpiSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedKpiGuid,
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalKpiSelect",
      "placeholder": _vm.lang.KM1008,
      "disabled": _vm.kpisOfSelectedKpiGroup.length < 1,
      "afterChange": _vm.selectedKpiGuidChanged
    },
    model: {
      value: (_vm.selectedKpiGuid),
      callback: function($$v) {
        _vm.selectedKpiGuid = $$v
      },
      expression: "selectedKpiGuid"
    }
  }, _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('option', {
      key: kpi.KPIGuid,
      domProps: {
        "value": kpi.KPIGuid
      }
    }, [_vm._v("\n                          " + _vm._s(kpi.KPICode) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.treeViewChanged
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.treeViewChanged || !_vm.selectedKpiGuid
    },
    on: {
      "click": function($event) {
        return _vm.saveKpiQuestionAssignmentData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.KM1012) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalSurveySelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1010))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedSurveyGuid,
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalSurveySelect",
      "placeholder": _vm.lang.KM1011,
      "disabled": _vm.surveysFromSelectedKpiGroup.length < 1,
      "afterChange": _vm.selectedSurveyGuidChanged
    },
    model: {
      value: (_vm.selectedSurveyGuid),
      callback: function($$v) {
        _vm.selectedSurveyGuid = $$v
      },
      expression: "selectedSurveyGuid"
    }
  }, _vm._l((_vm.surveysFromSelectedKpiGroup), function(survey) {
    return _c('option', {
      key: survey.SurveyGuid,
      domProps: {
        "value": survey.SurveyGuid
      }
    }, [_vm._v("\n                          " + _vm._s(survey.SurveyId) + " - " + _vm._s(survey.SurveyTitle) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "well",
    attrs: {
      "id": "liquortreeContainerWell"
    }
  }, [(_vm.showTree) ? _c('liquortree', {
    ref: "kpiQuestionAssignmentTree",
    attrs: {
      "data": _vm.treeData,
      "options": _vm.treeOptions
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;

        return _c('span', {
          staticClass: "tree-text"
        }, [(!node.data.IsCluster) ? [_c('div', {
          staticClass: "checkbox",
          staticStyle: {
            "margin": "0px",
            "padding-top": "3px"
          }
        }, [_c('label', [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": node.checked()
          },
          on: {
            "change": function($event) {
              return _vm.toggleQuestionCheckbox(node)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "checkbox-material"
        }, [_c('span', {
          staticClass: "check"
        })]), _vm._v(" "), _c('span', {
          staticClass: "ltree-types-and-points"
        }, [_vm._v("(" + _vm._s(_vm.convertQuestionTypeToLetter(node.data.Type)) + "|" + _vm._s(node.data.PointsMax ?
          node.data.PointsMax :
          0) + ")")]), _vm._v(" "), _c('span', {
          staticClass: "text-black",
          attrs: {
            "id": node.data.QuestionGuid
          }
        }, [_vm._v(_vm._s(node.text))]), _vm._v(" "), _c('b-tooltip', {
          ref: "tooltip",
          attrs: {
            "target": node.data.QuestionGuid,
            "delay": _vm.globals.tooltipDelay
          }
        }, [_vm._v(_vm._s(node.text))])], 1)])] : [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v(_vm._s(node.checked() || node.indeterminate() ?
          "folder" :
          "folder_open"))]), _vm._v(" "), _c('span', {
          attrs: {
            "id": node.data.PanelGuid
          }
        }, [_vm._v(_vm._s(node.text))]), _vm._v(" "), _c('b-tooltip', {
          ref: "tooltip",
          attrs: {
            "target": node.data.PanelGuid,
            "delay": _vm.globals.tooltipDelay
          }
        }, [_vm._v(_vm._s(node.text))])]], 2)
      }
    }], null, false, 3633694616)
  }) : _vm._e()], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.KM1009) + "\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5e52ff4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KPIManagement/KPIAssignmentModal.vue
// module id = 652
// module chunks = 1 2